<rpshared-mat-loading-card
	[isLoading]="(dataSource.state$ | async) === 'pending'"
	icon="attach_money"
	title="Cost Centers"
>
	<table mat-table [dataSource]="dataSource" matSort>
		<mat-text-column name="code"></mat-text-column>
		<mat-text-column name="description"></mat-text-column>
		<mat-text-column
			name="milePostRange"
			headerText="Mile Post Range"
		></mat-text-column>

		<ng-container matColumnDef="delete">
			<th mat-header-cell *matHeaderCellDef>Delete</th>
			<td mat-cell *matCellDef="let costCenter; let i = index">
				<button
					[disabled]="deletingMap[i]"
					type="button"
					mat-icon-button
					color="warn"
					rpsharedConfirm="Delete cost center?"
					(onConfirmed)="deleteCostCenter(costCenter, i)"
				>
					<mat-icon>delete</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="resultColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: resultColumns"></tr>
		<tr class="mat-row" *matNoDataRow>
			<td class="mat-cell text-center" colspan="4">
				No cost centers yet
			</td>
		</tr>
	</table>
	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator></mat-paginator>
		<button
			type="button"
			class="mr-4"
			mat-mini-fab
			color="primary"
			(click)="openAddCostCenterDialog()"
			matTooltip="Add Cost Center"
		>
			<mat-icon>add</mat-icon>
		</button>
	</div>
</rpshared-mat-loading-card>
